module.exports = __webpack_public_path__ + "static/media/user_icon_reseller.a0a7876b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_icon_reseller.svg
// module id = 106
// module chunks = 0